import { render, staticRenderFns } from "./P0242.vue?vue&type=template&id=31a8705c&"
import script from "./P0242.vue?vue&type=script&lang=ts&"
export * from "./P0242.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports